import config from "../config";
import { getAuthHeader, refreshAuthToken } from "../services/authToken";
import { generateSummaryUrl } from "../apiUrls/apiUrls";

const AiStreamResponse = async (params, onChunk, onDone,apiUrl) => {
  // The summary API needs the template's summary instructions and returns an
  // empty stream without them; a null value is also rejected by the API firewall.
  if (
    apiUrl === generateSummaryUrl() &&
    (typeof params?.serviceSummary !== "string" ||
      params.serviceSummary.trim() === "")
  ) {
    if (onDone) onDone();
    return;
  }

  let authHeader = getAuthHeader();
  if (!authHeader) {
    await refreshAuthToken();
    authHeader = getAuthHeader();
  }
  if (!authHeader) {
    throw new Error("Session expired. Please login again.");
  }

  const response = await fetch(`${config.localurl}${apiUrl}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': authHeader
    },
    body: JSON.stringify(params)
  });

  if (!response.ok) throw new Error('Failed to fetch AI response');

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    onChunk(chunk);
  }

  if (onDone) onDone();
};

export default AiStreamResponse;
